import React from 'react';
import {
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalTitle,
  ModalFooter,
  ModalLink,
  ModalLinkSecondary
} from './styled';
import iconWsp from '../../../assets/icons/IconWhatsapp.svg';
import imgCampaign from './assets/campaign_message.svg';
import iconGo from './assets/go_open.svg';
import Link from '@/presentation/reusables/Link';

interface IProps {
  option: any;
  hasRequired: boolean;
  isBlocked: boolean;
  handlerClose: () => void;
  goTo: () => void;
}

const ModalSurveysView = ({
  option,
  hasRequired,
  isBlocked,
  handlerClose,
  goTo
}: IProps) => (
  <ModalContent data-testid="cmp-surveys-content">
    <ModalHeader>
      <ModalTitle>
        <img src={imgCampaign} alt="ImgSurvey" />
        <p id="titleSurvey">
          <b>¡Hola! Tu opinión es importante</b>
        </p>
      </ModalTitle>
      <ModalTitle>
        <span>
          {option?.message && (
            <span style={{ marginTop: 10 }}>{option?.message} </span>
          )}
          {option?.dateBlock && <span> Completa </span>}
          {hasRequired && option?.messageBlack && (
            <span style={{ fontWeight: 'bold', padding: 0 }}>
              {option?.messageBlack}{' '}
            </span>
          )}
          {option?.dateBlock && (
            <span style={{ padding: 0 }}> antes del {option?.dateBlock} </span>
          )}
          {option?.message2 && <span>{option?.message2}</span>}
          {option?.messageExtra && (
            <>
              <br />
              <span>{option?.messageExtra}</span>
            </>
          )}
        </span>
      </ModalTitle>
    </ModalHeader>
    {isBlocked && (
      <ModalBody>
        <img src={iconWsp} alt="whatsapp" />
        <span>
          Para resolver tus dudas escríbenos al:{' '}
          <Link
            linkType="external"
            url={`https://api.whatsapp.com/send?phone=51960252970`}
            linkName="960 252 970"
          />
        </span>
      </ModalBody>
    )}
    <ModalFooter onlyOneButton={hasRequired}>
      <ModalLink onClick={goTo}>
        <img src={iconGo} alt="icoGo" width="24" height="24" />
        <span>Completar encuesta</span>
      </ModalLink>
      {!hasRequired && (
        <ModalLinkSecondary onClick={handlerClose}>Omitir</ModalLinkSecondary>
      )}
    </ModalFooter>
  </ModalContent>
);

export { ModalSurveysView };
